import { render } from "./doctor-medicine.vue?vue&type=template&id=6e900d17&scoped=true"
import script from "./doctor-medicine.vue?vue&type=script&lang=js"
export * from "./doctor-medicine.vue?vue&type=script&lang=js"

import "./doctor-medicine.vue?vue&type=style&index=0&id=6e900d17&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e900d17"]])

export default __exports__